import {generateAnonymousId} from '../../anonymousId'
import {parseQueryString, removeURLParameter} from '../../utils/url'
import {getCookie, setCookie} from '../utils/cookies'
import {warnServerEnvironment} from '../utils/logging/server-warning'
import cookieConfig from './cookieConfig'

/**
 * Remove the 'anonymousId' parameter from the current URL without reloading the page.
 */
export const removeAnonymousIdFromUrl = () => {
  const newUrl = removeURLParameter(location.href, 'anonymousId')
  history.replaceState(null, '', newUrl)
}

const getFromQueryString = () => {
  // Added for 0715b2bb-hack-skeletons
  if (typeof window === 'undefined') {
    warnServerEnvironment(`getQueryStringObject`)
    return null
  }

  const {anonymousId} = parseQueryString(location?.search || '')
  return anonymousId as string
}

const getFromCookie = () => getCookie(cookieConfig.name)

export const getAnonymousId = () => getFromQueryString() || getFromCookie()

/**
 * AnonymousId logic steps:
 *
 * 1 - Query string parameter: check if anonymousId parameter is present in the URL and use its value.
 * 2 - Cookie: check if anonymousId is already stored in a cookie and use its value.
 * 3 - Generate: use UUID to generate a new anonymousId.
 */
export const getOrGenerateAnonymousId = (): string =>
  getAnonymousId() || generateAnonymousId()

/**
 * Persist the anonymousId in a cookie
 * @param anonymousId
 */
export const persistAnonymousId = (anonymousId: string) => {
  const {secure, sameSite, domain, maxAge: expires} = cookieConfig.options

  setCookie(cookieConfig.name, anonymousId, {
    expires,
    secure,
    sameSite,
    domain
  })
}
